import React from 'react';
import { useFormContext } from 'react-hook-form';

import { ScreenEmailFemale } from './EmailFemale';
import { ScreenEmailMale } from './EmailMale';

import type { LayoutDataType } from '../../types';

export const ScreenEmail: React.FC = () => {
  const form = useFormContext<LayoutDataType>();
  const gender = form.watch('gender');

  if (gender === 'male') {
    return <ScreenEmailMale />;
  }

  return <ScreenEmailFemale />;
};
